// @flow
import type { Action } from "../actions/types";
import {
  FETCH_PASSBOOK,
  FETCH_PASSBOOK_SUCCESS,
  FETCH_PASSBOOK_ERROR
} from "../actions/types";

export type PassbookState = {
  fetching: boolean,
  passbook: {[key: string]: any} | null,
  selected: any,
  error: any | null,
};

const initialState = {
  fetching: false,
  passbook: null,
  selected: null,
  error: null,
  count: 0,
};

export const passbookReducer = (state: PassbookState = initialState, action: Action) => {
  const {type, payload} = action;

  switch (type) {
    case FETCH_PASSBOOK: 
      return {
        ...state,
        fetching: true,
        error: null,
      }

    case FETCH_PASSBOOK_SUCCESS:
      const { passbook = [], count = 0} = payload || {};
      return {
        ...state,
        fetching: false,
        error: null,
        passbook,
        count,
      }

    case FETCH_PASSBOOK_ERROR: 
      return {
        ...state,
        fetching: false,
        passbook: null,
        error: payload,
        count: 0,
      }

    default:
      return state;
  }
}